export default {
  name: 'publish-selection-menu-item',
  inject: [
    '$utils',
    '$signedInUserInfo'
  ],
  props: {
    allSchedules: {
      type: Array,
      required: true
    },
    allAvailbleUnselectedSchedules: {
      type: Array,
      required: true
    },
    getPlayerTagsColor: {
      type: Function,
      required: true
    },
    ledResolutionLabel: {
      type: String,
      default: () => ''
    }
  },
  data () {
    return {
      selectedPublishOption: '',
      isOptionsVisible: false,
      isDiscoveryAccount: this.$signedInUserInfo.activePlan.name === this.$utils.options.plans.DISCOVERY,
      closeTimeout: null
    }
  },
  computed: {
    searchKey () {
      return this.selectedPublishOption.toLowerCase() || '';
    },
    // The ALL PLAYER option
    allPlayerOption () {
      return this.allSchedules.find((option) => !option._edit.disabled && !option.userDefined && option.scheduleId === 'all')
    },
    // All active user defined player tags
    hasActivePlayerGroups () {
      return this.allSchedules.filter((option) => !option._edit.disabled && option.userDefined).length > 0
    },
    // All installed players
    hasInstalledPlayers () {
      return this.allSchedules.filter((option) => !option._edit.disabled && !option.userDefined && !['smart-tags', 'all'].includes(option.scheduleId)).length > 0
    },
    // Remaining player groups from selection
    unselectedPlayerGroups () {
      return this.allAvailbleUnselectedSchedules.filter((option) => !option._edit.disabled && option.userDefined)
    },
    // Remaining players from selection
    unselectedPlayers () {
      return this.allAvailbleUnselectedSchedules.filter((option) => !option._edit.disabled && !option.userDefined && !['smart-tags', 'all'].includes(option.scheduleId))
    },
    // Availble player groups after search filter applied
    filteredPlayerGroups () {
      if (!this.searchKey) return this.unselectedPlayerGroups

      return this.unselectedPlayerGroups.filter((pg) => pg.name.toLowerCase().includes(this.searchKey))
    },
    // Availble players after search filter applied
    filteredPlayers () {
      if (!this.searchKey) return this.unselectedPlayers

      return this.unselectedPlayers.filter((p) => p.name?.toLowerCase().includes(this.searchKey))
    },
    hasNoSearchMatchForPlayerGroups () {
      return this.filteredPlayerGroups.length < 1
    },
    hasNoSearchMatchForPlayers () {
      return this.filteredPlayers.length < 1
    },
    hasPlayerGroupLabel () {
      return this.unselectedPlayerGroups.length > 0 || this.hasNoSearchMatchForPlayerGroups || !this.hasActivePlayerGroups
    }
  },
  methods: {
    toggleDropdown () {
      // Toggle the visibility of the dropdown
      this.isOptionsVisible = !this.isOptionsVisible
    },
    closeDropdownWithDelay () {
      // clear previous timeout
      clearTimeout(this.closeTimeout)

      // Added delay to close the dropdown so click events on selection can happen first before closing
      this.closeTimeout = setTimeout(() => {
        this.isOptionsVisible = false
        this.$emit('hideDropdown')
      }, 200)
    },
    onOptionSelect (option) {
      if (option._edit.hideByTagUserRights || option._edit.notSupported) return

      this.$emit('selectPlayerOption', option.scheduleId)
    },
    onInputKeyupEnter () {
      const results = this.filteredPlayerGroups.concat(this.filteredPlayers)

      if (results.length === 1) {
        this.onOptionSelect(results[0])
      }
    },
    handleWarningClicked () {
      const supportedMedia = CONFIG.EXTERNAL_LINKS.supportedMedia
      if (supportedMedia) {
        window.open(supportedMedia, '_blank')
      }
    }
  },
  mounted () {
    // Set focus on the input to pop up selection
    this.$refs.input.focus()
  }
}
